import { render, staticRenderFns } from "./OperaCommunityUserPageWindow.vue?vue&type=template&id=4cd5b1b6&scoped=true"
import script from "./OperaCommunityUserPageWindow.vue?vue&type=script&lang=js"
export * from "./OperaCommunityUserPageWindow.vue?vue&type=script&lang=js"
import style0 from "./OperaCommunityUserPageWindow.vue?vue&type=style&index=0&id=4cd5b1b6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4cd5b1b6",
  null
  
)

export default component.exports